import styled from "styled-components";

const OverlayHeading = styled.h4`
  color: ${p => p.theme.colors.grey600};
  font-weight: 600;
  display: block;
  padding: 20px 24px 20px 15px;
  border-bottom: 1px solid ${p => p.theme.colors.grey100};

  .style--rebrand & {
    margin: 0;
    color: ${p => p.theme.colors.grey600};
  }
`;

export default OverlayHeading;
